import * as React from "react";
import { useState } from "react";
import * as styles from "./ContactForm.module.scss";
import CalendarForm from "./CalendarForm";
import RegularForm from "./RegularForm"

const Switch = props => {
  const { toggleForm, activeForm } = props;

  return (
    <div>
      <label style={{ display: "block" }}>
        <input
          className="toggle-input"
          type="checkbox"
          checked={activeForm}
          onChange={toggleForm}
          style={{ display: "none" }}
        />
        <span
          className={`${styles.toggle_btn} ${
            activeForm ? styles.toggle_btn_on : ""
          }`}
        />
      </label>
    </div>
  );
};

const ContactForm = () => {
  const [activeForm, setActiveForm] = useState(true);

  const toggleForm = () => {
    setActiveForm(!activeForm);
  }

  return (
    <div className={styles.form_container}>
      <h2 id="contact-form" className={styles.contact_form_title}>Let's Talk!</h2>

      <div className={styles.contact_toggle}>
        <h3>Contact Form</h3>
        <Switch toggleForm={toggleForm} activeForm={activeForm} />
        <h3>Schedule Call</h3>
      </div>
      <section>
        {activeForm ? (
          <div className={styles.means_container}>
          <RegularForm />
          </div>
        ) : (
            <CalendarForm />
        )}
      </section>
    </div>
  );
};

export default ContactForm;
